/**
 * ShellContext — the persistent-shell sentinel.
 *
 * Lives in its own tiny module to avoid the circular import that would
 * arise if it lived inside `AppShell.jsx` (AppShell imports Sidebar;
 * Sidebar reads the context).
 *
 * - `true`  → the current subtree is rendered inside the global AppShell
 * - `false` → standalone render (e.g. unauthenticated pages, tests)
 */
import { createContext, useContext } from "react";

export const ShellContext = createContext(false);

/** Returns true when rendered inside the global <AppShell />. */
export const useInShell = () => useContext(ShellContext);
